export default __webpack_public_path__ + "static/media/flowbuilders.5301f11e.png";